import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ProductsList from '@/views/product/ProductsList.vue'
import ProductDetail from '@/views/product/ProductDetail.vue'
import Loading from '@/plugins/loading'
import store from "@/store";
import i18n from '@/i18n'

Vue.use(VueRouter)
// 支持的语言列表
const SUPPORTED_LANGUAGES = ['zh', 'en', 'ja', 'ko', 'ru', 'es', 'fr', 'ar']
const baseRoutes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            breadcrumb: { name: '首页' }
        }
    },
    {
        path: '/products',
        name: 'products',
        component: () => import('@/views/product/index.vue'),
        meta: {
            breadcrumb: { name: '产品中心' }
        }
    },
    {
        path: '/ProductsSearch',
        name: 'productsSearch',
        component: () => import('@/views/product/ProductsSearchPage.vue'),
        meta: {
            breadcrumb: { name: '产品中心搜索' }
        }
    },
    {
        path: '/about-yacoo',
        name: 'about',
        component: () => import('@/views/about/about.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/about-yacoo/:component',
        name: 'about',
        component: () => import('@/views/about/about.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/about-us/company',
        name: 'AboutCompany',
        component: () => import('@/views/about/CompanyPage.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/about-us/production',
        name: 'AboutProduction',
        component: () => import('@/views/about/ProductionPage.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/contact-us',
        name: 'AboutContact',
        component: () => import('@/views/about/ContactPage.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/about-us/qualityControl',
        name: 'QualityControl',
        component: () => import('@/views/about/QualityControl.vue'),
        meta: {
            breadcrumb: { name: '关于亚科' }
        }
    },
    {
        path: '/information-center',
        name: 'news',
        component: () => import('@/views/NewsPage.vue'),
        meta: {
            breadcrumb: { name: '资讯中心' }
        }
    },
    {
        path: '/information-center/:component',
        name: 'news',
        component: () => import('@/views/NewsPage.vue'),
        meta: {
            breadcrumb: { name: '资讯中心' }
        }
    },
    {
        path: '/sustainable-development',
        name: 'sustainability',
        component: () => import('@/views/SustainabilityPage.vue'),
        meta: {
            breadcrumb: { name: '可持续发展' }
        }
    },
    {
        path: '/careers',
        name: 'careers',
        component: () => import('@/views/about/CareersPage.vue'),
        meta: {
            breadcrumb: { name: '加入我们' }
        }
    },
    {
        path: '/careersDetails',
        name: 'careersDetails',
        component: () => import('@/views/about/CareersDetails.vue'),
        meta: {
            breadcrumb: { name: '加入我们' }
        }
    },
    {
        path: '/products/list/:id',
        name: 'ProductsList',
        component: ProductsList,
        meta: {
            breadcrumb: { name: '产品列表' }
        }
    },
    {
        path: '/products/check',
        name: 'ProductCheck',
        component: () => import('@/views/product/check.vue'),
        meta: {
            breadcrumb: { name: '产品信息' }
        }
    },
    {
        path: '/products/biological-reagents/:id',
        name: 'ProductsOtherList',
        component: () => import('@/views/product/ProductsOtherList.vue'),
        meta: {
            breadcrumb: { name: '产品列表' }
        }
    },

    {
        path: '/products/Document',
        name: 'ProductsDocument',
        component: () => import('@/views/product/Document.vue'),
        meta: {
            breadcrumb: { name: '产品列表' }
        }
    },

    {
        path: '/products/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        meta: {
            breadcrumb: { name: '产品详情' },
            dynamicBreadcrumb: (route) => {
                return route.params.name || null;
            }
        }
    },
    {
        path: '/information-center/:component/:id',
        name: 'NewsDetails',
        component: () => import('@/views/NewsDetails.vue'),
        meta: {
            breadcrumb: { name: '新闻详情' }
        }
    },
    {
        path: '/searchPage',
        name: 'SearchPage',
        component: () => import('@/views/SearchPage.vue'),
        meta: {
            breadcrumb: { name: '搜索结果' }
        }
    },
    {
        path: '/other-businesses/scientific-research-procurement',
        name: 'KyCg',
        component: () => import('@/views/other/kycg.vue'),
        meta: {
            breadcrumb: { name: '其他服务' }
        }
    },
    {
        path: '/other-businesses',
        name: 'DzHc',
        component: () => import('@/views/other/dzhc.vue'),
        meta: {
            breadcrumb: { name: '其他服务' }
        }
    },
    {
        path: '/other-businesses/custom-synthesis',
        name: 'DzHc',
        component: () => import('@/views/other/dzhc.vue'),
        meta: {
            breadcrumb: { name: '其他服务' }
        }
    },
    {
        path: '/other-businesses/testing-services',
        name: 'JcFw',
        component: () => import('@/views/other/jcfw.vue'),
        meta: {
            breadcrumb: { name: '其他服务' }
        }
    },
    {
        path: '/other-businesses/green-energy',
        name: 'LsNy',
        component: () => import('@/views/other/lsny.vue'),
        meta: {
            breadcrumb: { name: '其他服务' }
        }
    },
    {
        path: '/industry-solutions',
        name: 'Solution',
        component: () => import('@/views/solution/index.vue'),
        meta: {
            breadcrumb: { name: '产品解决方案' }
        }
    },
    {
        path: '/innovation-production',
        name: 'Technology',
        component: () => import('@/views/technology.vue')
    },
    {
        path: '/innovation-production/:component',
        name: 'Technology',
        component: () => import('@/views/technology.vue')
    },
    {
        path: '/industry-solutions/:component',
        name: 'solutionModel',
        component: () => import('@/views/solution/model.vue')
    },
    {
        path: '/Agreement',
        name: 'Agreement',
        component: () => import('@/views/Agreement.vue')
    },
    {
        path: '/TermsOfService',
        name: 'TermsOfService',
        component: () => import('@/views/TermsOfService.vue')
    }
]



// 生成多语言路由
const generateLanguageRoutes = () => {
    const routes = []

    // 为每种语言生成路由
    SUPPORTED_LANGUAGES.forEach(lang => {
        baseRoutes.forEach(route => {
            const languageRoute = {
                ...route,
                path: `/${lang}${route.path}`,
                name: `${lang}_${route.name}`,
                meta: {
                    ...route.meta,
                    language: lang
                }
            }
            routes.push(languageRoute)
        })
    })

    // 添加默认路由（无语言前缀）
    routes.push(...baseRoutes)

    return routes
}

const routes = generateLanguageRoutes()

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL || '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

//获取当前语言，缓存优先
const getBrowserLang = () => {
    const savedLanguage = localStorage.getItem('language')
    if (savedLanguage && i18n.messages.hasOwnProperty(savedLanguage)) {
        return savedLanguage
    }

    const browserLang = navigator.language || navigator.userLanguage
    const langCode = browserLang.toLowerCase()
    const language = langCode.split('-')[0]

    // 检查是否支持该语言
    if (i18n.messages[language]) {
        return language
    }

    // 如果不支持，返回相近的语言或默认语言
    if (langCode.startsWith('en')) {
        return 'en'
    }
    return 'en'
}

// 从路径中提取语言
const extractLanguageFromPath = (path) => {
    const segments = path.split('/').filter(segment => segment)
    if (segments.length > 0 && SUPPORTED_LANGUAGES.includes(segments[0])) {
        return segments[0]
    }
    return null
}


router.beforeEach((to, from, next) => {
    Loading.show()


    // 处理多语言路由
    const pathLanguage = extractLanguageFromPath(to.path)
    const currentLanguage = localStorage.getItem('language') || getBrowserLang()

    // 如果路径中没有语言前缀，重定向到带语言前缀的路径
    if (!pathLanguage && currentLanguage !== 'en') {
        const newPath = `/${currentLanguage}${to.path}`
        // 添加检查，避免重定向到相同路径
        if (newPath !== to.path) {
            next({ path: newPath, query: to.query, hash: to.hash, replace: true })
            return
        }
    }

    // 如果路径中有语言前缀，更新当前语言设置
    if (pathLanguage && pathLanguage !== currentLanguage) {
        localStorage.setItem('language', pathLanguage)
        i18n.locale = pathLanguage
        store.dispatch('setLanguage', pathLanguage)
    }
    
    // 检查是否需要切换站点
    const shouldSwitchSite = checkAndSwitchSite(to)
    if (shouldSwitchSite) {
        return // 已经处理了跳转，不需要继续
    }
    
    next()
})

// 检查并切换站点的函数
const checkAndSwitchSite = (route) => {
    const currentHost = window.location.hostname
    const isCurrentlyMobile = isMobile()
    const isCurrentlyPC = !isCurrentlyMobile
    
    // 移动端检测
    if (isCurrentlyMobile) {
        // 如果当前在PC站点https://www.yacoo.com.cn/，但检测到是移动端，跳转到移动端站点
        if (currentHost === 'www.yacoo.com.cn') {
            const mobileHost = getMobileHost()
            window.location.href = `https://${mobileHost}${route.fullPath || route.path}`
            return true
        }
        return false
    }
    
    // PC端检测
    if (isCurrentlyPC) {
        // 如果当前不在PC站点，跳转到PC站点
        if (currentHost !== 'www.yacoo.com.cn') {
            window.location.href = `https://www.yacoo.com.cn${route.fullPath || route.path}`
            return true
        }
        return false
    }
    
    return false
}

// 获取移动端站点域名
const getMobileHost = () => {
    return 'mobile.yacoo.com.cn'
}

// 改进移动端检测函数，增加更多移动端标识和响应式检测
export const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    const mobileKeywords = [
        'phone', 'pad', 'pod', 'iphone', 'ipod', 'ios', 'ipad', 
        'android', 'mobile', 'blackberry', 'iemobile', 'mqqbrowser', 
        'juc', 'fennec', 'wosbrowser', 'browseng', 'webos', 
        'symbian', 'windows phone', 'opera mini', 'opera mobi'
    ]
    
    // 检查屏幕尺寸 - 使用更精确的断点
    const isSmallScreen = window.innerWidth <= 768
    const isMediumScreen = window.innerWidth <= 1024
    
    // 检查触摸支持
    const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    
    // 检查设备像素比
    const isHighDPIScreen = window.devicePixelRatio > 1
    
    // 综合判断：用户代理 + 屏幕尺寸 + 触摸支持 + 设备像素比
    const isMobileByUA = mobileKeywords.some(keyword => userAgent.includes(keyword))
    const isMobileByScreen = isSmallScreen || (isMediumScreen && hasTouchSupport)
    
    return isMobileByUA || isMobileByScreen
}

// 添加视窗宽度变化监听器
let resizeTimeout
const handleResize = () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
        const currentRoute = router.currentRoute
        checkAndSwitchSite(currentRoute)
    }, 300) // 防抖处理，300ms后执行
}

// 在路由初始化后添加事件监听器
router.afterEach(() => {
    Loading.hide()
    
    // 确保只添加一次事件监听器
    if (!window.hasResizeListener) {
        window.addEventListener('resize', handleResize)
        window.hasResizeListener = true
    }
})

// 在组件销毁时清理事件监听器
window.addEventListener('beforeunload', () => {
    if (window.hasResizeListener) {
        window.removeEventListener('resize', handleResize)
        window.hasResizeListener = false
    }
})

export default router
